import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Footer from '@/components/Footer'
import hearder from '@/components/hearder'
import image from '@/components/image/image'
import home from '@/components/home/home'
import News from '@/components/News/News'
import HomeNews from '@/components/home/HomeNews'
import TranSport from '@/components/transportation/TranSport'
import Facilities from '@/components/Facilities/Facilities'
import PerFormance from '@/components/PerFormance/PerFormance'
import Login from '@/components/Contact/Login'
import Register from '@/components/Contact/Register'
import NewMessage from '@/components/NewMessage/NewMessage'
import Dinnerlist from '@/components/Dinner/Dinnerlist'
import aboutUs from '@/components/aboutUs'
import contactUs from '@/components/contactUs'
import clinical from '@/components/clinical'
import clinicalNew from '@/components/clinicalNew'

import product from '@/components/product'
import news from '@/components/news'
import newsItem from '@/components/newsItem'
import companyProfile from '@/components/companyProfile'




Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,

    },

    {
      path: '/Footer',
      name: 'Footer',
      component: Footer
    },
    {
      path: '/hearder',
      name: 'hearder',
      component: hearder
    },
    {
      path: '/image',
      name: 'image',
      component: image
    }, {
      path: '/home',
      name: 'home',
      component: home
    },

    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },
    {
      path: '/clinical',
      name: 'clinical',
      component: clinical

    },

    {
      path: '/clinicalNew',
      name: 'clinicalNew',
      component: clinicalNew

    },
    {
      path: '/product',
      name: 'product',
      component: product

    },
    {
      path: '/news2',
      name: 'news',
      component: news

    },
    {
      path: '/newsItem',
      name: 'newsItem',
      component: newsItem

    },
    {
      path: '/companyProfile',
      name: 'companyProfile',
      component: companyProfile

    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js